
import { Helmet } from 'react-helmet';
import Footer from '@/components/home-main/Footer';
import Cursor from '@/components/common/cusor';
import ProgressScroll from '@/components/common/ProgressScroll';
import Lines from '@/components/common/Lines';
import Header from '@/components/login/Header';
import LoginForm from '@/components/login/LoginForm';

export default function LoginPage() {
  return (
    <>
    <Helmet>
        <title>GCAD - Join Us</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />  
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          {/* <Navbar /> */}
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <LoginForm />
            </main>
            <Footer/>
          </div>
        </div>
      </main>
    </>
  );
}
